import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (!["admin", "super_admin"].includes(user.role))
    return <Navigate to="/app/home" replace />;
  return children;
}

export function ProFeatureRoute({ feature, children }) {
  const { user } = useAuth();
  if (user === null) return <FullLoader />;
  return user?.pro_access ? children : <Navigate to={`/pro?feature=${feature}`} replace />;
}

export { FullLoader };
